import React from 'react';
import I18n from '@utils/i18n';
import { Text } from '@ui';
import { Tag } from '@ui/atoms/Tag';
export function ScheduledDateCell({ item }) {
    return (React.createElement("div", { className: "visits-table__date" },
        React.createElement(Text, { variant: "body" }, item.scheduledDateDisplay),
        item.primary && (React.createElement(Tag, { label: I18n.t('inspections.show.visits.primary'), variant: "gray", colorStyle: "solid", readOnly: true }))));
}
